function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { productDetailApi, productStockAddApi, productFreeEditApi } from '@/api/product';
import { mapGetters } from 'vuex';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import CdkeyLibrary from '@/views/product/components/cdkeyLibrary.vue';
import addCloudDisk from '@/views/product/components/addCloudDisk.vue';
import product from '@/mixins/product';
var defaultObj = {
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    vipPrice: 0,
    stock: 0,
    weight: 0,
    volume: 0,
    brokerage: 0,
    brokerageTwo: 0,
    isDefault: false,
    isShow: false,
    itemNumber: ''
  }],
  attr: [],
  specType: false
};
var objTitle = {
  price: {
    title: '售价（元）'
  },
  cost: {
    title: '供货价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  vipPrice: {
    title: '会员价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  },
  isDefault: {
    title: '是否默认'
  },
  isShow: {
    title: '是否展示'
  },
  itemNumber: {
    title: '商品条码'
  },
  stockAdd: {
    title: '增加库存'
  }
};
export default {
  name: 'edit',
  mixins: [product],
  //此js存放商品的部分函数方法
  components: {
    addCloudDisk: addCloudDisk,
    CdkeyLibrary: CdkeyLibrary
  },
  props: {
    //id
    productId: {
      type: Number || String,
      default: 0 || ''
    },
    //编辑库存true，免审编辑false
    stockEdit: {
      type: Boolean,
      default: false
    },
    //类型
    productType: {
      type: Number || String,
      default: 0 || ''
    },
    //佣金设置是否单独设置
    isSub: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      rules: {
        cateIds: [{
          required: true,
          message: '请选择商户商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        stockAdd: [{
          required: true,
          message: '请输入库存',
          trigger: 'blur'
        }]
      },
      formValidate: Object.assign({}, defaultObj),
      formThead: Object.assign({}, objTitle),
      isAttr: false,
      ManyAttrValue: [{
        image: '',
        price: 0,
        cost: 0,
        otPrice: 0,
        vipPrice: 0,
        stock: 0,
        weight: 0,
        volume: 0,
        stockAdd: 0
      }],
      // 规格
      manyTabTit: {},
      manyTabDate: {},
      loading: false,
      attrInfo: {},
      loadingBtn: false,
      cloudDisk: '',
      //云盘地址
      virtuallyIndex: 0,
      //索引
      cdkeyLibraryInfo: {} //卡密库对象
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['merProductClassify'])), {}, {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      if (this.formValidate.type === 2) {
        delete obj.itemNumber;
      }
      if (this.productType === 5) {
        delete obj.stock;
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      if (this.productType === 6) {
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      if (!this.isSub) {
        delete obj.brokerage;
        delete obj.brokerageTwo;
      }
      return obj;
    }
  }),
  watch: {
    // 'formValidate.attrList': {
    //   handler: function (val) {
    //     if (this.formValidate.specType && this.isAttr) this.watCh(val); //重要！！！
    //   },
    //   immediate: false,
    //   deep: true,
    // },
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.formValidate.specType) {
      // this.$watch('formValidate.attr', this.watCh);
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    checkPermi: checkPermi,
    // 补充卡密
    handlerToAddCdkey: function handlerToAddCdkey(row) {
      var _this$$router$resolve = this.$router.resolve({
          path: "/product/cdkey/creatCdkey/".concat(row.cdkeyId, "/").concat(row.cdkeyLibraryName)
        }),
        href = _this$$router$resolve.href;
      window.open(href);
    },
    //编辑卡密
    handlerEeditCdkey: function handlerEeditCdkey(index, data) {
      this.cdkeyLibraryInfo = {
        id: data.cdkeyId,
        name: data.cdkeyLibraryName
      };
      this.ManyAttrValue[index].expand = data.expand;
      this.virtuallyIndex = index;
      this.$refs.cdkeyLibrary.cdkeyShow = true;
    },
    //选择卡密库回调
    handlerChangeCdkeyIdSubSuccess: function handlerChangeCdkeyIdSubSuccess(row) {
      this.ManyAttrValue[this.virtuallyIndex].cdkeyLibraryName = row.name;
      this.ManyAttrValue[this.virtuallyIndex].cdkeyId = row.id;
    },
    //编辑云盘链接
    editVirtually: function editVirtually(index, data) {
      this.ManyAttrValue[index].expand = data.expand;
      this.virtuallyIndex = index;
      this.cloudDisk = data.expand;
      this.$refs.cloudDiskRef.cloudDiskShow = true;
    },
    //确认提交云盘链接
    handlerSubSuccessCloudDisk: function handlerSubSuccessCloudDisk(e) {
      this.cloudDisk = e;
      this.ManyAttrValue[this.virtuallyIndex].expand = JSON.parse(JSON.stringify(e));
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    closeCloudDisk: function closeCloudDisk() {
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    keyupEvent: function keyupEvent(key, val, index) {
      this.$forceUpdate();
      var regex = /^\d{1,6}(\.\d{1,2})?$/;
      var re = /^\D*([0-9](\d{1,5}(\.\d{1,2})?))?.*$/;
      // var re = /^\D*([0-9]\d*\.?\d{0,2})?.*$/;
      this.ManyAttrValue[index][key] = key === 'stock' ? parseInt(val) : regex.test(val) ? val : this.$set(this.ManyAttrValue[index], key, val.toString().replace(re, '$1'));
    },
    onSubmit: function onSubmit(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.stockEdit) {
            var data = [];
            var stockAdd = '';
            _this.ManyAttrValue.forEach(function (val, index) {
              stockAdd = val.stockAdd;
            });
            if (!stockAdd && stockAdd !== 0) return _this.$message.warning('增加库存不能为空');
            _this.ManyAttrValue.forEach(function (val, index) {
              data.push({
                id: val.id,
                stock: val.stockAdd ? val.stockAdd : 0
              });
            });
            productStockAddApi({
              attrValueList: data,
              id: _this.productId
            }).then(function (res) {
              _this.$message.success('操作成功');
              _this.$emit('subSuccess');
              _this.loadingBtn = false;
            }).catch(function (res) {
              _this.loadingBtn = false;
            });
          } else {
            var _data = [];
            _this.formValidate.cateId = _this.formValidate.cateIds.join(',');
            _this.ManyAttrValue.forEach(function (val, index) {
              _data.push({
                id: val.id,
                stock: val.stock,
                price: val.price,
                expand: val.expand,
                cdkeyId: val.cdkeyId
              });
            });
            productFreeEditApi({
              attrValue: _data,
              id: _this.productId,
              cateId: _this.formValidate.cateId
            }).then(function (res) {
              _this.$message.success('操作成功');
              _this.$emit('subSuccess');
              _this.loadingBtn = false;
            }).catch(function (res) {
              _this.loadingBtn = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    // 详情
    getInfo: function getInfo() {
      var _this2 = this;
      this.fullscreenLoading = true;
      productDetailApi(this.productId).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var tmp, tmpTab;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this2.isAttr = true;
                res.attrValueList.forEach(function (val) {
                  val.stockAdd = 0;
                });
                _this2.formValidate = {
                  attrValueList: res.attrValueList,
                  specType: res.specType,
                  cateIds: res.cateId.split(','),
                  // 商品分类id
                  cateId: res.cateId,
                  // 商品分类id传值
                  attrList: res.attrList
                };
                if (res.specType) {
                  _this2.ManyAttrValue = res.attrValueList;
                  _this2.ManyAttrValue = _this2.ManyAttrValue.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), JSON.parse(item.attrValue));
                  });
                  tmp = {};
                  tmpTab = {};
                  _this2.formValidate.attrList.forEach(function (o, i) {
                    tmp[o.attributeName] = {
                      title: o.attributeName
                    };
                    tmpTab[o.attributeName] = '';
                  });
                  _this2.manyTabTit = tmp;
                  _this2.manyTabDate = tmpTab;
                  _this2.formThead = Object.assign({}, _this2.formThead, tmp);
                } else {
                  _this2.ManyAttrValue = res.attrValueList;
                }
                //await this.getData(res, 'add');
                _this2.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this2.fullscreenLoading = false;
      });
    }
  }
};